import { useFormContext, Controller } from 'react-hook-form';
import { useRouteLoaderData } from 'react-router';
import InputBase from '../core/form/InputBase';
import TextBase from '../core/form/TextBase';
import SelectBase from '../core/form/SelectBase';
import MultiSelect from '../core/form/MultiSelect';
import ErrorMessage from '../parameters/fields/ErrorMessage';
import FormRow from '../core/form/FormRow';
import { PERMISSION_OPTIONS } from '@/consts';

const ModuleBaseForm = () => {
  const { projects } = useRouteLoaderData('choose-model');
  const projectOptions =
    projects?.results?.map(project => ({
      value: project.id,
      label: project.name,
    })) ?? [];

  const {
    register,
    formState: { errors },
    watch,
    control,
  } = useFormContext();

  const permissions = watch('permissions');

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-4">
        <div className="flex flex-col">
          <label className="block text-sm font-medium mb-2">Module Name</label>
          <InputBase
            hasError={!!errors.label}
            placeholder="Enter Module Name"
            {...register('label', { required: 'Module name is required' })}
          />
          <div className="h-4 mt-1">
            <ErrorMessage className="p-0" text={errors.label?.message} />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="form-control w-full group node">
            <FormRow label="Permissions" name="permissions" tooltip="Select who can access this model">
              <div className="join w-full">
                <SelectBase
                  {...register('permissions')}
                  name="permissions"
                  options={PERMISSION_OPTIONS}
                  isDefault={false}
                />
              </div>
            </FormRow>
          </div>

          {permissions === 'project' && (
            <div className="form-control w-full group node">
              <FormRow
                label="Selected Projects"
                name="project_ids"
                tooltip="Choose which projects can access this model"
              >
                <div className="join w-full">
                  <Controller
                    name="project_ids"
                    control={control}
                    defaultValue={[]}
                    rules={{
                      validate: value => {
                        if (permissions === 'project' && !value?.length) {
                          return 'Please select at least one project';
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <MultiSelect
                        options={projectOptions}
                        value={field.value}
                        onChange={field.onChange}
                        placeholder="Select projects..."
                        label="project"
                      />
                    )}
                  />
                </div>
              </FormRow>
              {errors?.project_ids?.message && (
                <div className="h-5">
                  <ErrorMessage text={errors?.project_ids?.message} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-col">
        <label className="block text-sm font-medium mb-2">Module Description</label>
        <TextBase {...register('description')} placeholder="Enter Module Description" rows={4} />
      </div>
    </div>
  );
};

export default ModuleBaseForm;
